import React from "react";

const Unauthorized = () => {
  return (
    <div>
      <p>You are authorized</p>
    </div>
  );
};

export default Unauthorized;
